module.exports = __webpack_public_path__ + "assets/img/thumb_ch3-item-2.c14d0209.jpg";